import React from 'react';
import { BookFilled } from '@/components/Icons/BookFilled';
import { ChevronRight } from '@/components/Icons/ChevronRight';

interface Props {
  name: string;
  teachers: string;
  onSelect: () => void;
}

export const JournalMobileCard: React.FC<Props> = ({
  name,
  teachers,
  onSelect,
}) => (
  <button
    type="button"
    onClick={onSelect}
    className="flex w-full cursor-pointer items-center gap-3 rounded-xl bg-popover p-4 text-left shadow-card transition-colors active:bg-on-primary-surface active:shadow-none contrast:border contrast:border-border"
  >
    <span className="flex size-8 shrink-0 items-center justify-center rounded-2xl bg-info-surface text-primary">
      <BookFilled className="size-4" />
    </span>

    <span className="flex min-w-0 flex-1 flex-col">
      <span className="text-subhead-14 truncate text-foreground">{name}</span>
      {!!teachers && (
        <span className="text-body-14 truncate text-muted-foreground">
          {teachers}
        </span>
      )}
    </span>

    <ChevronRight className="size-4 shrink-0 text-muted-foreground" />
  </button>
);
